import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { FacebookConnectModal } from './components/facebookConnectModal/facebookConnectModal';
import { FacebookLoginButton, } from './components/facebookLoginButton';
/** A component that displays a facebook login modal and it's associated modal. */
export const FacebookAuthenticator = ({ appId, children, platform, }) => {
    const dispatch = useAppDispatch();
    /** Handles the facebook authentication. */
    const handleFacebookAuthenticated = (facebookAuthenticationData) => {
        dispatch(appActions.showModal({
            modal: {
                type: 'settings:facebookConnect',
                arg: { appId, facebookAuthenticationData },
            },
        }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(FacebookLoginButton, Object.assign({ scope: "pages_show_list,pages_manage_metadata,pages_messaging,pages_read_engagement", onSuccess: handleFacebookAuthenticated, platform: platform }, { children: children })), _jsx(FacebookConnectModal, {})] }));
};
